import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';
import i18next from 'i18next';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getCollectionPointCategories(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
      }
      recordCount
    }
  }
`;

function useGetValues() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
}

interface LcFsProps extends FsProps {
  size?: 'sm' | 'lg';
}

export const FieldSelectCpCategory = ({
  label = i18next.t('Κατηγορία'),
  name = 'colpointCategoryId',
  defaultValues = {},
  size = 'sm',
  ...rest
}: LcFsProps) => {
  const where = ''; //JSON.stringify({ isNotActive: 0 });
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={where}
      hook={useGetValues}
      height={size === 'lg' ? 32 : '22'}
    />
  );
};
